<template>
  <div class="portfolio">

    <div class="container-header">
      <div class="container-header__title"> {{ i18n.lbl_investment_portfolio() }}</div>
    </div>

    <div v-if="tokens" class="portfolio__columns">
      <div class="portfolio__left-col">
        <portfolio-list @show-details="setCurrentAsset"
                        :tokens="tokens" />
      </div>
      <div class="portfolio__right-col">
        <portfolio-details :token="currentAsset" />
        <portfolio-transactions :token="currentAsset" />
      </div>
    </div>

    <div v-else>
      <not-available-card class="portfolio__not-available"
                          icon="work"
                          :title="i18n.lbl_no_investment_tokens()"
                          :descr="i18n.lbl_no_investment_tokens_desc()"/>
    </div>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'

  import PortfolioList from './Portfolio.List'
  import PortfolioDetails from './Portfolio.Details'
  import PortfolioTransactions from './Portfolio.Transactions'
  import NotAvailableCard from '../common/NotAvailableCard'
  export default {
    name: 'portfolio-index',
    components: {
      PortfolioList,
      PortfolioDetails,
      PortfolioTransactions,
      NotAvailableCard
    },
    data: _ => ({
      currentAsset: null,
      i18n
    }),
    async created () {
      await this.loadBalances()
    },
    computed: {
      ...mapGetters({
        tokens: vuexTypes.accountInvestmentBalances
      })
    },
    methods: {
      ...mapActions({
        loadBalances: vuexTypes.GET_ACCOUNT_INVESTMENT_BALANCES
      }),
      setCurrentAsset (value) {
        this.currentAsset = value
      }
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins.scss';

  .portfolio {

    &__columns {
      display: flex;
      justify-content: space-between;

      @include respond-to(large) {
        flex-direction: column;
      }
    }

    &__left-col {
      flex: 1 1 440px;
      max-width: 440px;
    }

    &__right-col {
      flex: 2 2 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 36px;
    }

    @include respond-to(large) {

      &__left-col,
      &__right-col {
        flex: 1 1 100%;
        max-width: 100%;
        width: 100%;
        margin: auto;
      }

      &__left-col {
        margin-bottom: 24px;
      }
    }
  }

  .portfolio__not-available {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/portfolio/Portfolio.Index.vue